var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAigRefer = function SvgIconAigRefer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#ECF4FE",
    rx: 10,
    transform: "matrix(1 0 0 -1 0 20)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D81F3",
    d: "M12.39 9.51a1.6 1.6 0 0 1 .078.49h2.679a.798.798 0 0 0-.137-.445l-4.347-6.452a.785.785 0 0 0-.525-.337l.076.016L12.39 9.51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#78CCFF",
    d: "m7.61 9.51 2.176-6.728a.787.787 0 0 0-.449.32L4.99 9.556a.798.798 0 0 0-.136.445h2.679c0-.166.025-.331.077-.49Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#55B4FB",
    d: "M7.61 10.493A1.597 1.597 0 0 1 7.533 10h-2.68c0 .156.046.312.137.448l4.348 6.45c.129.191.321.3.525.336-.026-.005-.052-.009-.077-.016L7.61 10.493Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0850AC",
    d: "M12.468 10c0 .166-.026.333-.078.493l-2.175 6.725c-.026.007-.051.011-.077.016a.785.785 0 0 0 .525-.337l4.348-6.45a.799.799 0 0 0 .136-.447h-2.68Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#006E87",
    d: "m10.488 3.103 4.258 6.452c.09.134.136.29.136.445h.264a.798.798 0 0 0-.136-.445l-4.348-6.452a.775.775 0 0 0-.446-.315l.027.083a.772.772 0 0 1 .245.232Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#003670",
    d: "M14.882 10a.798.798 0 0 1-.137.448l-4.257 6.45a.772.772 0 0 1-.245.232l-.027.083a.775.775 0 0 0 .446-.315l4.348-6.45a.798.798 0 0 0 .136-.448h-.264Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#55B4FB",
    d: "M7.532 10h4.935a1.6 1.6 0 0 0-.077-.49l-2.176-6.728a.867.867 0 0 0-.429 0L7.61 9.509c-.052.16-.078.325-.078.491Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#83E2FC",
    d: "M9.913 2.76c-.076.008-.096.015-.128.022L7.61 9.509c-.052.16-.078.325-.078.49h.496c0-.165.026-.33.078-.49L9.913 2.76Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0D81F3",
    d: "M12.39 10.493c.051-.16.077-.327.077-.493H7.532c0 .166.026.333.078.493l2.175 6.725c.13.036.298.036.429 0l2.176-6.725Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#33A3FF",
    d: "M9.913 17.237c-.095-.01-.097-.016-.128-.022L7.61 10.488a1.597 1.597 0 0 1-.078-.49h.496c0 .165.026.33.078.49l1.807 6.749Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#00809E",
    d: "M10.216 2.788 12.39 9.51c.051.159.077.325.077.49h.339c0-.165-.026-.331-.078-.49l-2.512-6.722Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFF8FF",
    d: "M9.539 2.898a.781.781 0 0 0-.202.205L4.99 9.555a.798.798 0 0 0-.136.445h.46c0-.155.045-.31.135-.445l4.09-6.657Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#003670",
    d: "m10.216 17.212 2.174-6.721a1.6 1.6 0 0 0 .077-.491h.339c0 .166-.026.331-.078.49l-2.512 6.722Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#85D1FF",
    d: "M9.539 17.102a.782.782 0 0 1-.202-.204L4.99 10.445A.798.798 0 0 1 4.854 10h.46c0 .155.045.31.135.445l4.09 6.657Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m12.988 6.553-2.325-3.45a.806.806 0 0 0-1.325 0l-3.969 5.89c3.98.243 6.287-.945 7.62-2.44Z",
    opacity: 0.15
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-AIG-refer_svg__a)",
    d: "M9.353 8.082a1.392 1.392 0 1 0 0-2.784 1.392 1.392 0 0 0 0 2.784Z",
    opacity: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-AIG-refer_svg__b)",
    d: "m9.564 6.8.403.504-.503-.403-.111.998-.11-.998-.504.403.403-.504-.998-.11.998-.111-.403-.503.503.402.11-.998.112.999.503-.403-.403.503.998.11-.998.111Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-AIG-refer_svg__c)",
    d: "M7.505 13.321c.343.582.712 1.148 1.104 1.684a21.38 21.38 0 0 0-2.047-3.468c.28.602.597 1.198.943 1.784Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-AIG-refer_svg__d)",
    d: "M11.013 14.408a1.855 1.855 0 1 0 0-3.71 1.855 1.855 0 0 0 0 3.71Z",
    opacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon-AIG-refer_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(9.353 6.69) scale(1.392)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#fff",
    stopOpacity: 0.999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon-AIG-refer_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(9.353 6.69) scale(1.20936)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon-AIG-refer_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(11.013 12.553) scale(1.85509)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#fff",
    stopOpacity: 0.999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-AIG-refer_svg__c",
    x1: 7.172,
    x2: 6.2,
    y1: 11.921,
    y2: 13.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#fff",
    stopOpacity: 0.999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};
export default SvgIconAigRefer;